var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdiomaIngles32X32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1978_117822)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1C61B1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.4834,
    height: 7.42369,
    transform: "matrix(0.755929 0.654654 -0.359211 0.933257 1.07764 -1.60861)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.1897,
    height: 2.47456,
    transform: "matrix(0.755929 0.654654 -0.359211 0.933257 -0.28125 1.83334)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.13,
    height: 7.42369,
    transform: "matrix(0.755929 -0.654654 0.359211 0.933257 -1.58887 26.5643)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.2306,
    height: 2.47456,
    transform: "matrix(0.755929 -0.654654 0.359211 0.933257 -0.28125 30.0506)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.068,
    height: 7.42369,
    transform: "matrix(-0.755929 -0.654654 0.35921 -0.933257 30.9424 33.4925)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.8917,
    height: 2.47456,
    transform: "matrix(-0.755929 -0.654654 0.359211 -0.933257 32.3013 30.0505)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9048,
    height: 7.42369,
    transform: "matrix(-0.755929 0.654654 -0.359211 -0.933257 33.6089 5.31961)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9256,
    height: 2.47456,
    transform: "matrix(-0.755929 0.654654 -0.359211 -0.933257 32.3013 1.83331)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.6667,
    width: 32,
    height: 10.6667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5557,
    width: 32,
    height: 7.11111,
    transform: "rotate(90 19.5557 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7778,
    width: 32,
    height: 3.55556,
    transform: "rotate(90 17.7778 0)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 13.3333,
    width: 32,
    height: 5.33333,
    fill: "#FF444B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1978_117822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdiomaIngles32X32);
export default __webpack_public_path__ + "static/media/IDIOMA_INGLES_32X32.044a7ae4fda3369153f8141d05ddf425.svg";
export { ForwardRef as ReactComponent };